export default __webpack_public_path__ + "static/media/squares500.66757876.jpg";